import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AnnouncementBar from "./components/AnnouncementBar";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import FreeAssessment from "./components/FreeAssessment";
import Philosophy from "./components/Philosophy";
import Director from "./components/Director";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CallButton from "./components/CallButton";
import ContactPage from "./pages/ContactPage";
import ThankYouPage from "./pages/ThankYouPage";
import ServicePage from "./pages/ServicePage";
import RoomsPage from "./pages/RoomsPage";
import RoomsPreview from "./components/RoomsPreview";
import AnalyticsEvents from "./components/AnalyticsEvents";

function HashScroll() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    }
  }, [location]);
  return null;
}

function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-brand-bg">
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Services />
        <RoomsPreview />
        <FreeAssessment />
        <Philosophy />
        <Director />
        <Contact />
      </main>
      <Footer />
      <CallButton />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsEvents />
        <HashScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/epikoinonia" element={<ContactPage />} />
          <Route path="/efcharistoume" element={<ThankYouPage />} />
          <Route path="/oi-choroi-mas" element={<RoomsPage />} />
          <Route path="/:slug" element={<ServicePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
